export const MIN_DAY_WORKTIME = 6 * 60 * 60 * 1000; // 6 hours worktime
export const MAX_DAY_WORKTIME = 8 * 60 * 60 * 1000; // 8 hours worktime
